var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03 21.77L16.35 15.7L31.04 19.66L17.84 25.96L3.03 21.77Z",
    fill: "#DDD7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11 16.73L16.42 10.67L31.12 14.63L17.92 20.93L3.11 16.73Z",
    fill: "#BFBEBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.14L16.32 6.07L31.01 10.04L17.81 16.33L3 12.14Z",
    fill: "#DDD7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/group3.8a8812323a394622b51d97716dad0d0c.svg";
export { ForwardRef as ReactComponent };